export default "__VITE_ASSET__CUxZT5UH__"